import React from 'react';
import { Box, Card } from 'grommet';

import LoginForm from 'src/scenes/login/components/LoginForm';

function LoginPage(): JSX.Element {
  return (
    <Box align='center' justify='center' height={{ min: '100vh' }}>
      <Card width='medium' pad='medium'>
        <LoginForm />
      </Card>
    </Box>
  );
}

export default LoginPage;
